import { render, staticRenderFns } from "./AccessCard.vue?vue&type=template&id=37a426f5"
import script from "./AccessCard.vue?vue&type=script&lang=ts"
export * from "./AccessCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports